
<p-button (click)="showDialog(); fetch(0)" icon="pi pi-search" label="Find parent" styleClass="p-button-outlined"></p-button>


<!-- MODAL PART-->
<p-dialog [(visible)]="display" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}"
          header="Search parent">
  <ng-template pTemplate="header">
    <h2 class="text-muted text-xs-center">Select Parent</h2>
  </ng-template>
  <ng-template pTemplate="content">

    <div class="pb-3 d-flex">
      <div class="mr-3">
        <div> Name:</div>
        <span class="p-float-label">
          <input [(ngModel)]="searchByName" pInputText type="text">
        </span>
      </div>
      <div class="mr-3">
        <div> Id:</div>
        <span class="p-float-label">
          <input [(ngModel)]="searchById" pInputText type="text">
        </span>
      </div>
      <div class="mr-3">
        <div>Keyword:</div>
        <span class="p-float-label">
          <input [(ngModel)]="searchByKeyword" pInputText type="text">
        </span>
      </div>
      <!--      <div class="mr-3">-->
      <!--        <div>Zip code:</div>-->
      <!--        <span class="p-float-label">-->
      <!--          <input type="text" [(ngModel)]="searchByZipCode" pInputText>-->
      <!--        </span>-->
      <!--      </div>-->

      <div class="mt-4 mr-3">
        <button (click)="fetch()" class="p-button-outlined ml-3" icon="pi pi-search" pButton></button>
      </div>
    </div>

    <table class="table table-hover">
      <thead class="grey-colour">
      <tr>
        <th>Parent Id</th>
        <th>Last Name</th>
        <th>First Name</th>
        <th>Phone</th>
        <th>Email</th>
        <th>Children</th>
        <th>Bookings</th>
        <th>Referral code</th>
        <th>In Service Area?</th>
        <th>Active?</th>
      </tr>
      </thead>
      <tbody *ngIf="!isLoading">
      <tr
        (click)="selectedParent = parent"
        *ngFor="let parent of parentList; let i = index;"
        [ngStyle]="{'background-color': (parent === selectedParent) ? '#73c7af' : '#ffffff'}">
        <td><a [routerLink]="['/dashboard', 'parent' ,'detail', parent.id]">{{ parent.id }}</a></td>
        <td>{{ parent.lastName }}</td>
        <td>{{ parent.firstName }}</td>
        <td>{{ parent.phoneNumber }}</td>
        <td>{{ parent.email }}</td>
        <td>{{ parent?.children.length }}</td>
        <td>{{ parent?.completedBookings }}</td>
        <td>{{ parent?.referralCode }}</td>

        <td>
          <p-checkbox [ngModel]="parent?.inServiceArea" [binary]="true" [disabled]="true"></p-checkbox>
        </td>
        <td>
          <p-checkbox [ngModel]="parent?.active" [binary]="true" [disabled]="true"></p-checkbox>
        </td>
      </tr>
      </tbody>
    </table>


    <div class="flex justify-content-center">
      <p-paginator #paginator (onPageChange)="paginate($event)" [rows]="10" [totalRecords]="totalRecords"></p-paginator>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button (click)="select()" [disabled]="!selectedParent" icon="pi pi-check" label="Select"></p-button>
  </ng-template>
</p-dialog>
